var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.785156,
    y: 0.5,
    width: 41,
    height: 31,
    rx: 7.5,
    stroke: "#FF9777"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3824 10.3248C17.7433 9.1455 19.4844 8.4975 21.2852 8.50001C25.4274 8.50001 28.7852 11.8578 28.7852 16C28.7852 17.602 28.2827 19.087 27.4277 20.305L25.0352 16H27.2852C27.2853 14.8237 26.9396 13.6734 26.2912 12.6919C25.6427 11.7105 24.7201 10.9414 23.638 10.4801C22.556 10.0188 21.3622 9.88578 20.2051 10.0975C19.0481 10.3093 17.9787 10.8564 17.1302 11.671L16.3824 10.3248ZM26.1879 21.6753C24.827 22.8545 23.0859 23.5025 21.2852 23.5C17.1429 23.5 13.7852 20.1423 13.7852 16C13.7852 14.398 14.2877 12.913 15.1427 11.695L17.5352 16H15.2852C15.2851 17.1763 15.6307 18.3267 16.2792 19.3081C16.9276 20.2895 17.8502 21.0586 18.9323 21.5199C20.0143 21.9812 21.2081 22.1142 22.3652 21.9025C23.5223 21.6908 24.5916 21.1436 25.4402 20.329L26.1879 21.6753Z",
    fill: "#FF9777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.209f5b7a7ceaca6e05ac3b9a3e417a53.svg";
export { ForwardRef as ReactComponent };